import CustomOrderAddEventItem from './custom-order-add-event-item';

export default CustomOrderAddEventItem;
